import { BaseDataListResponse } from 'Base'
import volunteerRequest from 'api/volunteerRequest'
import { RegistrationEventData } from 'Models'
import { useCallback, useEffect, useState } from 'react'
import { DEFAULT_PAGE_TABLE_SIZE } from 'utils/constants/commons-constant'
import type { VolunteerEventSummary } from './types'

const getDefaultFilterData = () => ({
  page: 1,
  perPage: DEFAULT_PAGE_TABLE_SIZE,
  keyword: '',
})

export function useVolunteerRegistrationList(eventId: string) {
  const [loadingListing, setLoadingListing] = useState(false)
  const [filterData, setFilterData] =
    useState<Record<string, unknown>>(getDefaultFilterData)
  const [listData, setListData] = useState<
    BaseDataListResponse<RegistrationEventData>
  >({
    meta: { perPage: DEFAULT_PAGE_TABLE_SIZE, page: 1, total: 0 },
    data: [],
  })
  const [currentEvent, setCurrentEvent] = useState<VolunteerEventSummary | null>(
    null
  )

  const fetchList = useCallback(
    async (params: Record<string, unknown>) => {
      if (!eventId) return
      setLoadingListing(true)
      try {
        const { data } = await volunteerRequest.request({
          url: `/api/v1/reservation/event/${eventId}`,
          params,
        })
        setListData(data)
        setCurrentEvent(data.event)
      } catch {
        /* volunteerRequest handles toast */
      } finally {
        setLoadingListing(false)
      }
    },
    [eventId]
  )

  useEffect(() => {
    void fetchList(filterData)
  }, [fetchList, filterData])

  const handleFilterDataChange = useCallback((next: Record<string, unknown>) => {
    setFilterData({ ...getDefaultFilterData(), ...next })
  }, [])

  const refetch = useCallback(() => {
    void fetchList(filterData)
  }, [fetchList, filterData])

  return {
    loadingListing,
    filterData,
    listData,
    currentEvent,
    handleFilterDataChange,
    refetch,
  }
}
